import { render, staticRenderFns } from "./ResourceSeatingCapacity.vue?vue&type=template&id=49520b24"
import script from "./ResourceSeatingCapacity.vue?vue&type=script&lang=js"
export * from "./ResourceSeatingCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports